const GetFTPGatewayLogs = 
  `query getFTPGatewayLogs($count: Int, $cursor: String, $filterConfig: FTPGatewayLogFilterConfigInput) {
    ftpGatewayLogs(first: $count, after: $cursor, filterConfig: $filterConfig) {
      pageInfo {
        hasNextPage
      }
      edges {
        cursor
        node {
          id
          failed
          timestamp
          executionStartTime
          dataSource {
            id
          }
        }
      }
    }
  }
 `

const GetFTPGatewayLog = `
  query getFTPGatewayLog($id: String!) {
    ftpGatewayLog(id: $id) {
      id
      failed
      timestamp
      executionStartTime
      logURL
      businessLog {
        type
        timestamp
        message
      }
      dataSource {
        id
        name
        description
      }
    }
  }
`
module.exports = {
  GetFTPGatewayLog,
  GetFTPGatewayLogs
}